// extracted by mini-css-extract-plugin
module.exports = {"selectBlock":"Language_selectBlock__1l9e3"};